import { render, staticRenderFns } from "./CtrlKanriHimmoku.vue?vue&type=template&id=91996f5a&"
import script from "./CtrlKanriHimmoku.vue?vue&type=script&lang=ts&"
export * from "./CtrlKanriHimmoku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports